export default __webpack_public_path__ + "static/media/logo.37e77a6e.svg";